import React from 'react';
import styled from 'styled-components';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const PageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  position: relative;
  background: #000;
  color: #fff;
  overflow: hidden;
  isolation: isolate;
`;

const ContentContainer = styled.div`
  position: relative;
  z-index: 50;
  padding: 0 5%;
  pointer-events: auto;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const MessageSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  max-width: 900px;
  margin: 0 auto;
  padding: 2rem;
`;

const Title = styled.h1`
  font-size: 3rem;
  margin-bottom: 1.5rem;
  color: white;
  line-height: 1.2;
  font-weight: bold;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.79);

  @media (max-width: 768px) {
    font-size: 2.2rem;
  }
`;

const Subtitle = styled.p`
  font-size: 1.4rem;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 2rem;
  line-height: 1.6;
  max-width: 700px;

  @media (max-width: 768px) {
    font-size: 1.1rem;
  }
`;

const BackButton = styled.a`
  padding: 12px 30px;
  border: none;
  border-radius: 30px;
  background: linear-gradient(45deg, rgb(255, 255, 255), rgb(236, 236, 236));
  color: black;
  font-size: 1.1rem;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  font-weight: 500;
  text-decoration: none;
  display: inline-block;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.9);
  }
`;

function InProgress() {
  return (
    <PageContainer>
      <Navbar />
      <ContentContainer>
        <MessageSection>
          <Title>
            Oops, looks like you ran into some turbulence!
          </Title>
          <Subtitle>
            This page is currently under construction. Our team is working hard to bring you cutting-edge geospatial solutions.
          </Subtitle>
          <BackButton href="/">
            Return to Home
          </BackButton>
        </MessageSection>
        <Footer />
      </ContentContainer>
    </PageContainer>
  );
}

export default InProgress; 